import { createContext, useContext } from "react";

import { ObservableWorkflowNode } from "@/components/Workflows/types";

export const NodeContext = createContext<ObservableWorkflowNode | null>(null);

export const useNode = () => useContext(NodeContext);
